export default __webpack_public_path__ + "static/media/img-id-back.a08b7773.svg";